import { render, staticRenderFns } from "./post-preview-page.vue?vue&type=template&id=1a1e8dbb&scoped=true&"
import script from "./post-preview-page.vue?vue&type=script&lang=js&"
export * from "./post-preview-page.vue?vue&type=script&lang=js&"
import style0 from "./post-preview-page.vue?vue&type=style&index=0&id=1a1e8dbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1e8dbb",
  null
  
)

export default component.exports